import AppModal from '~/components/molecules/AppModal.vue'

const Modal = {
  install(Vue) {
    Vue.component('app-modal', AppModal)

    Vue.prototype.$modal = {
      show(params) {
        Vue.prototype.$eventBus.$emit('show-modal', params)
      }
    }
  }
}

export default Modal
